import { render, staticRenderFns } from "./CustomDateField.vue?vue&type=template&id=47d506e1"
import script from "./CustomDateField.vue?vue&type=script&lang=js"
export * from "./CustomDateField.vue?vue&type=script&lang=js"
import style0 from "./CustomDateField.vue?vue&type=style&index=0&id=47d506e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports